import { Box, BoxProps, IconButton, HStack, Text } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { useState } from "react";
import Container from "./Container";

interface CollapsibleContainerProps extends BoxProps {
  children: React.ReactNode;
  head?: React.ReactNode;
  defaultCollapsed?: boolean;
  onToggle?: (isCollapsed: boolean) => void;
}

const CollapsibleContainer = ({
  children,
  defaultCollapsed = true,
  onToggle,
  head = <></>,
  ...props
}: CollapsibleContainerProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleToggle = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    onToggle?.(newCollapsedState);
  };

  return (
    <Container {...props}>
      <HStack
        justify="space-between"
        align="center"
        mb={isCollapsed ? 0 : 4}
        w="full"
      >
        <Box flexGrow={1}>{head}</Box>
        <IconButton
          aria-label={isCollapsed ? "Expand" : "Collapse"}
          variant="outline"
          rounded="full"
          w={10}
          h={6}
          shadow="sm"
          icon={
            isCollapsed ? (
              <ChevronDownIcon fontSize={30} />
            ) : (
              <ChevronUpIcon fontSize={30} />
            )
          }
          size="sm"
          onClick={handleToggle}
          color="gray.500"
          _hover={{ bg: "gray.100" }}
        />
      </HStack>

      {!isCollapsed && children}
    </Container>
  );
};

export default CollapsibleContainer;
